import { Routes, Route } from "react-router-dom";
import { RegistrationPage } from "@/pages/RegistrationPage";
import { Page } from "@/common";
import { checkPaymentPageRoute } from "./check-payment";
import { dashboardsPageRoute } from "./dashboards";
import { notesPageRoute } from "./notes";
import { commitmentsPageRoute } from "./commitments";
import { signUpPageRoute } from "./sign-up";
import { logInPageRoute } from "./log-in";
import { ProtectedRoute } from "./ProtectedRoute";
import { AuthRoute } from "./AuthRoute";
import { ideasPageRoute } from "./ideas";
import { settingsPageRoute } from "./settings";
import { calendarV2PageRoute } from "./calendarV2/config";
import { checkStatusPageRoute } from "./check-status";
import { passwordRecoveryPageRoute } from "./password-recovery";
import { mobilePaymentPageRoute } from "./mobile-payments";
import {
  contactsActivitiesRouteV2,
  contactsCommitmentsRouteV2,
  contactsConnectionsRouteV2,
  contactsGeneralInfoRouteV2,
  contactsIdeasRouteV2,
  contactsNotesRouteV2,
  contactsPageV2Route,
} from "./contactsV2";

export const AppRouting = () => {
  return (
    <Routes>
      <Route path="/" element={<ProtectedRoute>{<Page />}</ProtectedRoute>}>
        <Route
          index
          path={dashboardsPageRoute.path}
          element={<ProtectedRoute>{dashboardsPageRoute.element}</ProtectedRoute>}
        />
        <Route
          path={contactsPageV2Route.path}
          element={<ProtectedRoute>{contactsPageV2Route.element}</ProtectedRoute>}
        >
          <Route
            path={contactsGeneralInfoRouteV2.path}
            element={<ProtectedRoute>{contactsGeneralInfoRouteV2.element}</ProtectedRoute>}
          />
          <Route
            path={contactsConnectionsRouteV2.path}
            element={<ProtectedRoute>{contactsConnectionsRouteV2.element}</ProtectedRoute>}
          />
          <Route
            path={contactsActivitiesRouteV2.path}
            element={<ProtectedRoute>{contactsActivitiesRouteV2.element}</ProtectedRoute>}
          />
          <Route
            path={contactsNotesRouteV2.path}
            element={<ProtectedRoute>{contactsNotesRouteV2.element}</ProtectedRoute>}
          />
          <Route
            path={contactsIdeasRouteV2.path}
            element={<ProtectedRoute>{contactsIdeasRouteV2.element}</ProtectedRoute>}
          />
          <Route
            path={contactsCommitmentsRouteV2.path}
            element={<ProtectedRoute>{contactsCommitmentsRouteV2.element}</ProtectedRoute>}
          />
        </Route>
        <Route
          path={notesPageRoute.path}
          element={<ProtectedRoute>{notesPageRoute.element}</ProtectedRoute>}
        />
        <Route
          path={commitmentsPageRoute.path}
          element={<ProtectedRoute>{commitmentsPageRoute.element}</ProtectedRoute>}
        />
        <Route path={ideasPageRoute.path} element={ideasPageRoute.element} />
        <Route
          path={calendarV2PageRoute.path}
          element={<ProtectedRoute>{calendarV2PageRoute.element}</ProtectedRoute>}
        />
        <Route
          path={settingsPageRoute.path}
          element={<ProtectedRoute>{settingsPageRoute.element}</ProtectedRoute>}
        />
      </Route>
      <Route path="auth" element={<RegistrationPage />}>
        <Route
          path={signUpPageRoute.path}
          element={<AuthRoute>{signUpPageRoute.element}</AuthRoute>}
        />
        <Route
          path={logInPageRoute.path}
          element={<AuthRoute>{logInPageRoute.element}</AuthRoute>}
        />
        <Route
          path={checkStatusPageRoute.path}
          element={<AuthRoute>{checkStatusPageRoute.element}</AuthRoute>}
        />
        <Route
          path={checkPaymentPageRoute.path}
          element={<AuthRoute>{checkPaymentPageRoute.element}</AuthRoute>}
        />
        <Route
          path={passwordRecoveryPageRoute.path}
          element={<AuthRoute>{passwordRecoveryPageRoute.element}</AuthRoute>}
        />
        <Route
          path={mobilePaymentPageRoute.path}
          element={<AuthRoute>{mobilePaymentPageRoute.element}</AuthRoute>}
        />
      </Route>
    </Routes>
  );
};
